import { render, staticRenderFns } from "./TrainingCertificates.vue?vue&type=template&id=4ec3b67a&scoped=true"
import script from "./TrainingCertificates.vue?vue&type=script&lang=js"
export * from "./TrainingCertificates.vue?vue&type=script&lang=js"
import style0 from "./TrainingCertificates.vue?vue&type=style&index=0&id=4ec3b67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3b67a",
  null
  
)

export default component.exports